//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TestLendingLibraryInputItem extends ItemBase {
    StudentIndex: number = 0;
    TeacherIndex: number = 0;
    Name: string | null = null;
    Type: string | null = null;
    PrivateNote: string | null = null;
    PublicNote: string | null = null;
    Publisher: string | null = null;
    SerialNumber: string | null = null;

    constructor(initializer?: Partial<TestLendingLibraryInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestLendingLibraryInputItem";
}
